import {
  fetchNotificationCenterCounters,
  fetchNotificationCenterDeadlines,
  fetchNotificationCenterTable,
} from "../../../redux/features/notification-center/notificationCenterSlice";
import {
  NOTIFICATION_CENTER_DEADLINES_TAB_ID,
  NOTIFICATION_CENTER_PAGE_SIZE,
} from "../../../redux/features/notification-center/notificationCenterConstants";

export const NOTIFICATION_CENTER_PATH = "/notification-center";

export function isNotificationCenterPath(pathname) {
  return String(pathname ?? "").startsWith(NOTIFICATION_CENTER_PATH);
}

/** First open of NC page — counters only; active tab loads in page component. */
export function fetchNotificationCenterPageInitial(dispatch) {
  return dispatch(fetchNotificationCenterCounters({ silent: true }));
}

/** Polling / post-action refresh — active table page + counters. */
export function fetchNotificationCenterPageSilent(
  dispatch,
  { tableId, offset = 0, limit = NOTIFICATION_CENTER_PAGE_SIZE, showAll = false } = {}
) {
  const tasks = [
    dispatch(fetchNotificationCenterCounters({ silent: true, showAll })),
  ];

  if (tableId === NOTIFICATION_CENTER_DEADLINES_TAB_ID) {
    tasks.push(
      dispatch(fetchNotificationCenterDeadlines({ silent: true, showAll }))
    );
  } else if (tableId) {
    tasks.push(
      dispatch(
        fetchNotificationCenterTable({
          tableId,
          offset,
          limit,
          silent: true,
          showAll,
        })
      )
    );
  }

  return Promise.all(tasks);
}
